import React, { useEffect, useRef, useState } from 'react';

import { TextField } from '@mui/material';

import Styles from '../lib/Styles';
import classes from './SelectField.module.scss';

export default function SelectMessageBody(props: any) {
  const {selectedMessageBody, setSelectedMessageBody, onChangeMessageBody, readOnly } = props;
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  const [lengthMessageBody, setLengthMessageBody] = useState<number>(selectedMessageBody ? selectedMessageBody.length : 0);
  const [showHelper, setShowHelper] = useState<boolean>(false);
  const maxNumberOfCharacters: number = 400;

  useEffect(() => {
    if (initialValue.current) {
      setLengthMessageBody(initialValue.current.length);
      setSelectedMessageBody(initialValue.current);
      initialValue.current = undefined;
    }
  }, [setSelectedMessageBody])

  const handleMessageBodyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    let lengthValue = value.length;
    if (lengthValue > maxNumberOfCharacters) {
      value = value.substr(0, maxNumberOfCharacters);
    }
    setLengthMessageBody(value.length);
    setSelectedMessageBody(value);
    onChangeMessageBody();
  };

  return (
    <form className={cx('root')} noValidate autoComplete="off">
      <div>
        <TextField
          disabled={readOnly}
          label="Campaign Message"
          helperText={ !showHelper ? '' : (maxNumberOfCharacters - lengthMessageBody).toLocaleString() +  ' characters left'}
          multiline
          defaultValue={undefined}
          inputProps={{
            readOnly: readOnly
          }}
          variant="outlined"
          value={selectedMessageBody}
          onInput={handleMessageBodyChange}
          onFocus={() => setShowHelper(true)}
          onBlur={() => setShowHelper(false)}
          placeholder="Enter campaign message to send."
          required={true}
        />
      </div>
    </form>
  );
}